import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Table,
  Divider,
  List,
  Avatar,
  Select,
  Button,
  Tag,
  Tabs,
  DatePicker,
  Icon,
  Switch,
  message,
} from "antd";
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import "./styles.module.scss";
import styles from "./styles.module.scss";
import { API_HOST } from "../../configs/env";
import whttp from "../../libs/whttp";
import axios from "axios";
import buildURL from "axios/lib/helpers/buildURL";
import DeleteConfirmButton from "components/DeleteConfirmButton/DeleteConfirmButton";
import { genFormItemAtrribute } from "libs/FormHelper";
import AppHelper from "libs/AppHelper";

const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Search = Input.Search;
const Option = Select.Option;

const { RangePicker } = DatePicker;

export default class StoreList extends Component {
  formRef = React.createRef();
  state = {
    tableData: {
      current: 0, //目前頁數
      page_size: 10, //一頁幾筆
      total: 0, //以此query條件，總共幾筆資料
      rows: [],
    },
    table_query: {
      keyword: null,
      roles: [],
      status: [],
      citys: [],
      fields: [],
      group: null,
      area: null,
      store_type: null,
    },
    ui_state: {
      isLoading: false,
    },
    message: "",
    keyword: "",
    permission: "all",
  };
  componentDidMount() {
    AppHelper.updateConfig();
    this.loadData();
  }
  // 拉Table資料
  loadData = (opt = { page: 1, page_size: 10 }) => {
    const { table_query } = this.state;
    const tableQuery = this.formRef.current.getFieldValue();
    const { page, page_size } = opt;

    //分店管理列表加入分店管理帳號顯示過濾 by Sam 2022/03/18
    const current_user = _.get(window, "VC_CONFIG.WP_CURRENT_USER", "");
    const user_id = current_user.ID;

    this.setState({ isLoadingData: true });

    whttp.get(
      API_HOST + "/api/mgt/v1/stores",
      {
        page: page,
        page_size: page_size,
        keyword: _.get(tableQuery, "keyword"),
        group: _.get(tableQuery, "store_group_id"),
        area: _.get(tableQuery, "store_area_id"),
        store_type: _.get(tableQuery, "store_type_id"),
        user_id: user_id,
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          return this.setState({ message: "發生錯誤" });
        }

        if (code !== 200) {
          return this.setState({ message: reason });
        }

        this.setState({ tableData: data });
      }
    );
  };
  // 匯出
  exportData = () => {
    const { table_query } = this.state;

    this.setState({ isExportData: true });
    axios({
      url: buildURL(API_HOST + "/api/mgt/v1/stores/export", {
        keyword: table_query.keyword,
        email: "user@gmail.com",
        format: "xlsx",
      }),
      method: "GET",
      responseType: "blob", // important
      headers: whttp.getHeaders(),
    })
      .then((response) => {
        this.setState({ isExportData: false });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "export.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        this.setState({ isExportData: false });

        let res = { code: 200, reason: "未知錯誤", error: error, data: {} };

        if (error.response) {
          res.code = error.response.status;
          res.reason = error.response.statusText;
        }

        message.warning("無法匯出:" + error.message);
      });
  };

  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });

    whttp.delete(
      API_HOST + `/api/mgt/v1/stores/${item.id}`,
      {},
      (state, res) => {
        item.isDeleteData = false;
        this.setState({ isDeleteData: false });
        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          return message.error("發生錯誤");
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success("刪除成功");

        this.loadData();
      }
    );
  };
  cloneData = (item) => {
    if (_.isNil(item.id)) return;

    item.isCloneData = true;

    this.setState({ isCloneData: true });

    whttp.post(
      API_HOST + `/api/mgt/v1/stores/${item.id}/clone`,
      {},
      (state, res) => {
        item.isCloneData = false;
        this.setState({ isCloneData: false });
        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          return message.error("發生錯誤");
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success("複製成功");

        if (!_.isNil(data.id))
          this.props.history.push(`/stores/view/${data.id}`);
      }
    );
  };
  //變更使用者狀態
  submitUserStatusData = (status, user_id, callback = (result) => {}) => {
    this.setState({ isSubmitUserStatusData: true });

    whttp.post(
      API_HOST + `/api/v1/user/status/${user_id}`,
      {
        status: status,
      },
      (state, res) => {
        this.setState({ isSubmitUserStatusData: false });

        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          callback(false);

          return message.warning("發生錯誤");
        }

        if (code !== 200) {
          callback(false);

          return message.warning(reason);
        }
        callback(true);
      }
    );
  };

  //更新時間
  submitBranchTime = () => {
    whttp.post(
      API_HOST + `/api/mgt/v1/stores/updateBranchTime`,
      (state, res) => {
        console.log(res);
        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          return message.warning("發生錯誤");
        }

        if (code !== 200) {
          return message.warning(reason);
        }
      }
    );
  };

  render() {
    const { table_query = {}, tableData = {} } = this.state;

    const {
      app: {
        options: { fields: optionFields = [] },
      },
    } = this.props;
    const permissions = _.get(this.props, "auth.permissions", {});
    const options = _.get(this, "props.app.options", {});
    const privileges = _.get(window, "VC_CONFIG.privileges");
    return (
      <Layout>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/stores`}>分店管理</Link>
          </Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          分店管理
          <span />
        </h2>

        <div className="block search">
          {/*<h3>搜尋<span></span></h3>*/}
          <Form
            ref={this.formRef}
            onValuesChange={(changedFields, allFields) =>
              console.log("onValuesChange", changedFields)
            }
          >
            <div className="flexBox col_12">
              <FormItem
                {...genFormItemAtrribute("keyword", "名稱")}
                label="名稱"
              >
                <Input placeholder="搜尋名稱、代號、代碼" />
              </FormItem>
            </div>
            <Form.Item
              {...genFormItemAtrribute("store_area_id", "分店所在地區")}
            >
              <Select placeholder="請選擇分店所在地區">
                <option value={null}>請選擇分店所在地區</option>
                {_.map(_.get(options, "store_areas", []), (item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item {...genFormItemAtrribute("store_group_id", "分店群組")}>
              <Select placeholder="請選擇分店群組">
                <option value={null}>請選擇分店群組</option>
                {_.map(_.get(options, "store_groups", []), (item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item {...genFormItemAtrribute("store_type_id", "分店型態")}>
              <Select placeholder="請選擇分店型態">
                <option value={null}>請選擇分店型態</option>
                {_.map(_.get(options, "store_types", []), (item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/*<div className='flexBox col_12'>
              <Form.Item {...genFormItemAtrribute('group', '分店群組')}
                rules={[{ required: false, message: '請選擇分店群組' }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {_.map(_.get(options, 'store_groups', []), item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
              </Form.Item>
                </div>*/}

            <Form.Item style={{ textAlign: "right" }}>
              <Button
                onClick={(event) => {
                  this.formRef.current.resetFields();
                  this.setState({ tableQuery: {} });
                  this.loadData();
                }}
              >
                取消
              </Button>

              {/* <Button type='primary' style={{ marginLeft: 8 }} loading={this.state.isExportData} onClick={(event) => this.exportData()}>匯出分店基本資料</Button>

              <Button type='primary' style={{ marginLeft: 8 }} loading={this.state.isExportData} onClick={(event) => this.exportData()}>匯出Line BC分店資料</Button> */}

              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                icon={<SearchOutlined />}
                onClick={(event) => this.loadData()}
              >
                搜尋
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div className="toolbar">
          <h3>
            分店列表
            <span />
          </h3>
          <Form layout="inline">
            <Form.Item>
              <div className="flexBox">
                {/* permissions['service:edit'] && <Button>權限按鈕</Button> */}
                {/* <Button type="primary" onClick={(event) => this.submitBranchTime()}>更新時間</Button> */}
                {_.get(privileges, "stores.create", false) === true && (
                  <Link to={`/stores/view`}>
                    <Button
                      type="primary"
                      onClick={() => {
                        this.props.history.push(
                          `${
                            process.env.PUBLIC_URL
                          }/experience-center/service/info/`
                        );
                      }}
                    >
                      新增
                    </Button>
                  </Link>
                )}
              </div>
            </Form.Item>
          </Form>
        </div>

        <Table
          dataSource={tableData.rows}
          loading={this.state.isLoadingData}
          pagination={{
            current: _.get(tableData, "current", []),
            total: _.get(tableData, "total", 0),
            pageSize: _.get(tableData, "page_size", 0),
            onChange: (page, page_size) => {
              this.loadData({ page: page, page_size: page_size });
            },
          }}
          columns={[
            { dataIndex: "id", title: "ID" },
            {
              dataIndex: ["images", "0"],
              title: "樓層圖",
              render: (image) => (
                <Avatar shape="square" icon={<ShopOutlined />} src={image} />
              ),
            },
            { dataIndex: "name", title: "名稱" },
            { dataIndex: "code", title: "代號" },
            { dataIndex: "sn", title: "代碼" },
            { dataIndex: "store_area_name", title: "地區" },
            { dataIndex: "store_group_name", title: "地區" },
            { dataIndex: "store_type_name", title: "類型" },
            { dataIndex: "sort", title: "排序" },
            { dataIndex: "status_name", title: "狀態" },
            { dataIndex: "updated_at", title: "更新時間" },
            { dataIndex: ["modified_user", "name"], title: "異動者" },
            {
              title: "Action",
              key: "tools",
              render: (text, record) => {
                const privileges = _.get(window, "VC_CONFIG.privileges", {});
                const storesModify = _.get(privileges, "stores.modify", []);
                const canCreate = _.get(privileges, "stores.create", false);
                const canEdit =
                  _.indexOf(storesModify, "all") !== -1 ||
                  _.indexOf(storesModify, record.id) !== -1;
                const dataSource = [];
                if (canCreate)
                  dataSource.push(
                    <DeleteConfirmButton
                      loading={record.isDeleteData === true}
                      size="small"
                      onConfirm={() => this.deleteData(record)}
                    />
                  );
                if (canCreate || canEdit)
                  dataSource.push(
                    <Link role="button" to={`/stores/view/${record.id}`}>
                      <Button
                        type="default"
                        size="small"
                        icon={<FormOutlined />}
                      >
                        編輯
                      </Button>
                    </Link>
                  );
                if (dataSource.length === 0) return <Fragment />;
                return (
                  <List
                    grid={{ gutter: 4, column: 3 }}
                    dataSource={dataSource}
                    renderItem={(item) => <List.Item>{item}</List.Item>}
                  />
                );
              },
            },
          ]}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Store/StoreList.js